export default {
  GET_TABLE_LIST: '/manage/inci/findList',
  UPDATE_DETAIL: '/manage/inci/update',
  GET_DETAIL: '/manage/inci/detail',
  GET_COUNTRY_LIST: '/manage/inci/getReleaseCountries',
  UPLOAD_FILE: '/manage/inci/upload',
  UPDATE_INCI: '/manage/inci/submitAndUpdate',
  FIND_INCI: '/auth/trade/inci/findINCIFilter'
}



// WEBPACK FOOTER //
// ./src/axios/api_urls/inciManagement.js